import { ButtonGroup, Button, Box } from '@mui/material';
// import IconButton from '@mui/material/IconButton';
// import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import React, { useState } from 'react';
import NetworkTeacherInvite from './NetworkTeacherInvite';
import NetworkSchoolInvite from './NetworkSchoolInvite';

export const NetworkSchool = props => {
    const [teachers, setTeachers] = useState(true);

    return (
        <>
            <Box
                sx={{
                    display: 'block',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    margin: 2,
                }}
            >
                <ButtonGroup
                    variant="contained"
                    aria-label="choose teachers or schools to add to view on your network"
                >
                    <Button
                        onClick={() => {
                            setTeachers(true);
                        }}
                        variant={teachers ? 'contained' : 'outlined'}
                    >
                        Teachers
                    </Button>

                    <Button
                        onClick={() => {
                            setTeachers(false);
                        }}
                        variant={teachers ? 'outlined' : 'contained'}
                    >
                        Schools
                    </Button>
                </ButtonGroup>
            </Box>
            {teachers ? (
                <NetworkTeacherInvite
                    network={props.network}
                    pk1={props.pk1}
                    crtList={props.crtList}
                    teacherList={props.teacherList}
                    profile={props.profile}
                />
            ) : (
                <NetworkSchoolInvite network={props.network} pk1={props.pk1} />
            )}
        </>
    );
};

export default NetworkSchool;
